import { MEDIA_QUERIES } from "common/mediaQueryAdapter";
import { attrToBool } from "common/helpers";

let globalEnabled = true;
let adapters = new Set();
function setEnabled(enabled) {
  globalEnabled = enabled;
  for (let adapter of adapters) {
    adapter.setValue(adapter.value);
  }
}
class AnimationAdapter {
  mediaQuery = window.matchMedia(MEDIA_QUERIES.reducedMotion);
  config = {
    enabled: true,
  };
  get enabled() {
    if (this.mediaQuery.matches) {
      return false;
    }
    if (globalEnabled === false) {
      return false;
    }
    return this.config.enabled ?? true;
  }
  get value() {
    return {
      enabled: this.enabled,
    };
  }
  constructor(setValue) {
    this.setValue = setValue;
    adapters.add(this);
  }
  onChange = () => {
    this.setValue(this.value);
  };
  connect() {
    this.setValue(this.value);
    this.mediaQuery.addEventListener("change", this.onChange);
  }
  disconnect() {
    this.mediaQuery.removeEventListener("change", this.onChange);
    adapters.delete(this);
  }
  update(config) {
    this.config = {
      ...config,
      enabled:
        typeof config.enabled !== "undefined"
          ? attrToBool(config.enabled)
          : undefined,
    };
    this.setValue(this.value);
  }
}

export { AnimationAdapter, setEnabled };
